import SmileysWidget from './SmileysWidget';
export default SmileysWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/SmileysWidget/index.js